export default {
    methods: {
      currencyName(data) {
        return "MMK."+data
      },
    },
  };